import React from 'react';
import { useSelector } from 'react-redux';
import classes from './CharacterCard.module.css';
import Icon from '../../../ui/icons/Icon';
import iconsList from '../../../ui/icons/iconsList';

const CharacterCard = ({ character, isSelected, isTeacher, onClick }) => {
  const { texts } = useSelector(state => state.translate);

  return (
    <div
      className={`${classes.card} ${character.isCurrentCharacter ? classes.currentCharacter : ''} ${isSelected && isTeacher ? classes.teacherSelected : ''}`}
      onClick={onClick}
    >
      <h3 className={classes.characterName}>{texts[character.nameKey] || character.nameKey}</h3>
      <div className={classes.imageContainer}>
        <img
          src={character.cardImage}
          alt={character.nameKey}
          className={classes.characterImage}
        />
      </div>
      {character.id === 1 ? (
        <div className={classes.openLabel}>
          {texts["characterWorld.open"]}
        </div>
      ) : (
        <div className={classes.starsContainer}>
          <Icon 
            name={iconsList.star} 
            size="24.994px"
            className={`${classes.starIcon} ${character.isUnlocked ? classes.starFilled : ''}`}
          />
          <span className={classes.starsCount}>{character.requiredStars}</span>
        </div>
      )}
    </div>
  );
};

export default CharacterCard;

